import React from "react";
import styles from "../styles/campaignNotifications.module.scss";
import CampaignUserRow from "./CampaignUserRow";

export default function CampaignUsersTable({
  users = [],
  audience,
  selectedSlugs,
  excludedIds = new Set(),
  isSelectAll = false,
  onToggle,
}) {
  const selectable = audience === "eligible" || audience === "all";

  return (
    <div className={styles.tableWrap} style={{ border: "none", boxShadow: "none" }}>
      <table className={`${styles.dataTable} ${styles.usersTable}`}>
        <colgroup>
          {selectable ? <col className={styles.checkboxCell} /> : null}
          <col />
          <col className={styles.metaCol} />
          <col className={styles.dateCol} />
          <col className={styles.dateCol} />
        </colgroup>
        <thead>
          <tr>
            {selectable ? <th className={styles.checkboxCell} /> : null}
            <th className={styles.userHeading}>User</th>
            <th className={`${styles.centerCell} ${styles.metaCol}`}>
              {selectable ? "Last notification" : "Status"}
            </th>
            <th className={`${styles.centerCell} ${styles.dateCol}`}>
              {selectable ? "Last sent" : "Sent at"}
            </th>
            <th className={`${styles.centerCell} ${styles.dateCol}`}>
              Last active
            </th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <CampaignUserRow
              key={user.send?.slug || user.slug || index}
              user={user}
              index={index}
              audience={audience}
              selected={Boolean(
                user.slug &&
                  (isSelectAll
                    ? !excludedIds.has(user.slug)
                    : selectedSlugs.has(user.slug))
              )}
              onToggle={onToggle}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
